<template>
  <div>
    <v-container>
      <div class="md-12 lg-12 xs-12 sm-12">
        <p class="primary--text display-1 font-weight-bold pt-8">Biblioteca</p>
        <v-card class="overflow-hidden" color="transparent" flat>
          <div class="d-flex flex-column flex-md-row">
            <div class="d-flex flex align-center">
              <span
                class="title primary--text font-weight-bold pr-4 d-none d-md-flex"
                >Filtros</span
              >
              <v-chip-group
                class="ml-2 flex"
                show-arrows
                v-model="filterSelection"
                active-class="font-weight-bold"
                mandatory
                @change="onChangeSearchText"
              >
                <v-chip
                  color="secondary"
                  dark
                  large
                  :outlined="0 !== filterSelection"
                  >Más frecuentes</v-chip
                >
                <v-chip
                  :outlined="1 !== filterSelection"
                  color="secondary"
                  large
                  >Más abundates</v-chip
                >
                <v-chip
                  :outlined="2 !== filterSelection"
                  color="secondary"
                  large
                  >Más buscados</v-chip
                >
                <v-chip
                  :outlined="3 !== filterSelection"
                  color="secondary"
                  large
                  >Todos</v-chip
                >
              </v-chip-group>
            </div>
            <v-spacer></v-spacer>
            <div class="flex">
              <v-text-field
                class="align-end"
                v-model="searchText"
                @input="onChangeSearchText"
                outlined
                clearable
                hide-details
                rounded
                prepend-inner-icon="search"
                placeholder="Buscar"
              ></v-text-field>
            </div>
          </div>
        </v-card>
      </div>
      <v-divider class="mt-6 primary"></v-divider>
      <v-sheet color="transparent" flat>
        <v-container>
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="scrollInfiniteDisabled"
            infinite-scroll-distance="10"
          >
            <transition-group
              name="slide-x-transition"
              tag="div"
              class="d-flex flex-wrap mt-4"
              hide-on-leave
            >
              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="4"
                v-for="organism in organismList"
                :key="organism.id"
              >
                <LibraryCard :item="organism"></LibraryCard>
              </v-col>
            </transition-group>
          </div>
          <transition>
            <div v-if="loading">
              <v-row class="pa-4 pt-0">
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  lg="4"
                  v-for="(item, index) of [1, 2, 3, 4, 5, 6, 7, 8, 9]"
                  :key="index"
                >
                  <v-skeleton-loader
                    class="mx-auto"
                    type="card"
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
            </div>
          </transition>
        </v-container>
      </v-sheet>
    </v-container>
    <v-img :src="jureles" height="200" full-width></v-img>
  </div>
</template>

<script>
import LibraryCard from "./LibraryCard";
import api from "../../api.js";
export default {
  components: { LibraryCard },
  data: () => ({
    searchText: "",
    filterSelection: 3,
    organism: {},
    organismList: [],
    orgMostFrequent: [],
    orgAbundantFrequent: [],
    orgMostSearched: [],
    loading: true,
    page: 1,
    limit: 15,
    scrollInfiniteDisabled: false,
    jureles: require("@/assets/landing/jureles.jpg"),
    _timerId: null
  }),
  methods: {
    async filterData() {
      //3 Especies mas frecuentes
      try {
        this.orgMostFrequent = [];
        let { data: orgMostFrequent } = await this.$http.get("organism", {
          params: {
            where: {
              validated: true,
              ocurrenceFrecuency: { "!=": 0 },
              deleted: false
            },
            sort: "ocurrenceFrecuency DESC",
            limit: 3
          }
        });
        this.orgMostFrequent = orgMostFrequent;
      } catch (err) {
        //console.log(err);
      }

      //3 Especies mas abundantes (promedios filtros abundancia por especie)
      try {
        this.orgAbundantFrequent = [];
        let { data: orgAbundantFrequent } = await this.$http.get("organism", {
          params: {
            where: {
              weightAbundance: { "!=": 0 }
            },
            sort: "weightAbundance DESC",
            limit: 3
          }
        });
        this.orgAbundantFrequent = orgAbundantFrequent;
      } catch (err) {
        //console.log(err);
      }

      //Mas buscadas
      try {
        this.orgMostSearched = [];
        let { data: orgMostSearched } = await this.$http.get("organism", {
          params: {
            where: {
              mostSearched: { "!=": 0 }
            },
            sort: "mostSearched DESC",
            limit: 3
          }
        });
        this.orgMostSearched = orgMostSearched;
      } catch (err) {
        //console.log(err);
      }
    },
    async getData() {
      try {
        this.loading = true;
        this.scrollInfiniteDisabled = true;
        if (this.filterSelection === 0) {
          let { data: organismList } = await this.$http.get("organism", {
            params: {
              where: {
                searchText: { contains: (this.searchText || "").toLowerCase() },
                ocurrenceFrecuency: { "!=": 0 },
                sp_card: true
              },
              sort: "ocurrenceFrecuency DESC",
              limit: this.limit,
              skip: (this.page - 1) * this.limit
            }
          });
          setTimeout(() => {
            this.organismList.push(...organismList);
            if (organismList.length == this.limit) {
              this.scrollInfiniteDisabled = false;
            }
          }, 200);
        } else if (this.filterSelection === 1) {
          let { data: organismList } = await this.$http.get("organism", {
            params: {
              where: {
                searchText: { contains: (this.searchText || "").toLowerCase() },
                weightAbundance: { "!=": 0 },
                sp_card: true
              },
              sort: "mostSearched DESC",
              limit: this.limit,
              skip: (this.page - 1) * this.limit
            }
          });
          setTimeout(() => {
            this.organismList.push(...organismList);
            if (organismList.length == this.limit) {
              this.scrollInfiniteDisabled = false;
            }
          }, 200);
        } else if (this.filterSelection === 2) {
          let { data: organismList } = await this.$http.get("organism", {
            params: {
              where: {
                searchText: { contains: (this.searchText || "").toLowerCase() },
                mostSearched: { "!=": 0 },
                sp_card: true
              },
              sort: "mostSearched DESC",
              limit: this.limit,
              skip: (this.page - 1) * this.limit
            }
          });
          setTimeout(() => {
            this.organismList.push(...organismList);
            if (organismList.length == this.limit) {
              this.scrollInfiniteDisabled = false;
            }
          }, 200);
        } else {
          let { data: organismList } = await this.$http.get("organism", {
            params: {
              where: {
                searchText: { contains: (this.searchText || "").toLowerCase() },
                sp_card: true
              },
              limit: this.limit,
              skip: (this.page - 1) * this.limit
            }
          });
          setTimeout(() => {
            this.organismList.push(...organismList);
            if (organismList.length == this.limit) {
              this.scrollInfiniteDisabled = false;
            }
          }, 200);
        }
      } catch (err) {
        //console.log(err);
      }
      this.loading = false;
    },
    async loadMore() {
      this.page++;
      this.getData();
    },
    async onChangeSearchText() {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        this.organismList = [];
        this.page = 1;
        this.getData();
      }, 800);
    }
  },
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    }
  },
  mounted: function() {
    this.getData();
    // this.filterData();
  }
};
</script>

<style></style>
